import React, { useState } from 'react';
import Link from 'next/link';
import { ChevronDown } from 'lucide-react';
import logoBrand from '../../assets/img/header/logo.png';

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    setActiveDropdown(null); // Close any open dropdowns when menu closes
  };

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  const navItems = [
    { name: "Company", links: ["About Us"] },
    {
      name: "Services",
      links: [
        {
          name: "BIM Service",
          subLinks: [
            "Point Cloud to BIM",
            "As built BIM Drawing",
            "MEP BIM Services",
            "Laser Scan to BIM",
          ]
        },
        {
          name: "CAD Drafting",
          subLinks: ["Scan To CAD"]
        },
        "Shop Drawing"
      ]
    },
    { name: "Hire Talent", links: ["Hire BIM Modelers"] },
    { name: "Projects", links: ["Case Studies"] },
    { name: "Blog", href: "/blog" }
  ];

  return (
    <nav className="navbar">
      <div className="logo-container">
        <Link href="/">
          <img
            src={logoBrand.src || logoBrand}
            alt="Logo"
            style={{ height: "40px", objectFit: "contain", cursor: "pointer" }}
          />
        </Link>
      </div>

      {/* Hamburger for Mobile */}
      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <div className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}>
          <span></span><span></span><span></span>
        </div>
      </div>

      <div className={`nav-links ${mobileMenuOpen ? 'mobile-active' : ''}`}>
        {navItems.map((item, index) => {
          const isDropdown = !!item.links;
          return (
            <div
              className={`nav-item ${isDropdown && activeDropdown === index ? 'active' : ''}`}
              key={index}
            >
              <div
                className="nav-link-wrapper"
                onClick={() => isDropdown && toggleDropdown(index)}
              >
                {isDropdown ? (
                  <a href="#" className="nav-link" onClick={(e) => e.preventDefault()}>
                    {item.name}
                    <ChevronDown
                      size={14}
                      className={`dropdown-icon ${activeDropdown === index ? 'rotated' : ''}`}
                    />
                  </a>
                ) : (
                  <Link
                    href={item.href || `/${item.name.toLowerCase().replace(/ /g, '')}`}
                    className="nav-link"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                )}
              </div>
              {isDropdown && (
                <div className={`dropdown-menu ${activeDropdown === index ? 'mobile-show' : ''}`}>
                  {item.links.map((link, subIndex) => {
                    const isObject = typeof link === 'object';
                    const linkName = isObject ? link.name : link;
                    const hasSubLinks = isObject && link.subLinks;

                    let href = `/${linkName.toLowerCase().replace(/ /g, '')}`;
                    if (linkName === "About Us") {
                      href = "/Company/aboutus";
                    }
                    if (linkName === "Contact Us") {
                      href = "/contactus"; // Explicitly match file name
                    }
                    if (linkName === "Case Studies") {
                      href = "/casestudy/casestudy"; // Point to the gallery list as requested
                    }
                    if (item.name === "Services") {
                      const slug = linkName === "BIM Service" ? "bimservice" : linkName.toLowerCase().replace(/ /g, '-');
                      href = `/service/${slug}`;
                    }
                    if (item.name === "Hire Talent") {
                      if (linkName === "Hire BIM Modelers") {
                        href = "/HireTalent/HireBIMModelers";
                      }
                    }

                    if (hasSubLinks) {
                      return (
                        <div className="dropdown-submenu-parent" key={subIndex}>
                          <Link
                            href={href}
                            className="dropdown-link has-submenu"
                            onClick={() => {
                              if (window.innerWidth > 1024) {
                                setMobileMenuOpen(false);
                                setActiveDropdown(null);
                              }
                            }}
                          >
                            {linkName}
                            <ChevronDown size={18} className="submenu-icon" />
                          </Link>
                          <div className="submenu-dropdown">
                            {link.subLinks.map((subLink, childIndex) => (
                              <Link
                                key={childIndex}
                                href={`${href}/${subLink.toLowerCase().replace(/ /g, '-')}`}
                                className="submenu-link"
                                onClick={() => {
                                  setMobileMenuOpen(false);
                                  setActiveDropdown(null);
                                }}
                              >
                                {subLink}
                              </Link>
                            ))}
                          </div>
                        </div>
                      );
                    }

                    return (
                      <Link
                        href={href}
                        key={subIndex}
                        className="dropdown-link"
                        onClick={() => {
                          setMobileMenuOpen(false);
                          setActiveDropdown(null);
                        }}
                      >
                        {linkName}
                      </Link>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
        <Link
          href="/contactus"
          className="nav-link mobile-contact-link"
          onClick={() => setMobileMenuOpen(false)}
        >
          Contact Us
        </Link>
      </div>

      <Link href="/contactus" className="btn-contact">
        Contact Us
      </Link>
    </nav>
  );
};

export default Navbar;
